<template>
  <div
    class="gf-input"
    :class="inputClasses"
  >
    <input
      :id="name"
      :ref="name"
      v-model="value"
      v-mask="mask"
      :type="type"
      :name="name"
      :placeholder="placeholder"
      :autofocus="autofocus"
      autocomplete="off"
      class="gf-input__input"
      @input="onInput($event.target.value)"
      @blur="onBlur"
      @focus="onFocus"
    >
    <label
      v-if="isLabelVisible"
      class="gf-input__label"
      :for="name"
    >
      {{ label }}
    </label>
    <p
      v-if="errorMessage"
      class="gf-input__error"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'InputV2',

  props: {
    label: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    name: {
      type: String,
      required: true,
    },

    type: {
      type: String,
      default: 'text',
    },

    modelValue: {
      type: String,
      default: '',
    },

    isError: {
      type: Boolean,
      default: false,
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },

    errorText: {
      type: String,
      default: '',
    },

    mask: {
      type: String,
      default: '',
    },

    autofocus: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    'blur',
    'focus',
    'input',
  ],

  data () {
    return {
      value: '',
    }
  },

  computed: {
    inputClasses () {
      return {
        'gf-input--error': this.isError,
      }
    },

    errorMessage () {
      if (this.errorText && this.isError) {
        return this.errorText
      }
      return ''
    },

    isLabelVisible () {
      return this.label && this.value
    },
  },

  mounted () {
    if (this.autofocus) {
      this.$refs[this.name].focus()
    }

    if (this.modelValue) {
      this.value = this.modelValue
    }
  },

  methods: {
    onInput (value) {
      this.$emit('input', value)
    },

    onBlur () {
      this.$emit('blur')
    },

    onFocus () {
      this.$emit('focus')

      if (!this.value && this.type === 'tel') {
        this.value = '+7'
      }
    },
  },
}
</script>

<style lang="scss">
.gf-input {
  $this: &;

  position: relative;

  &:has(input:focus) #{$this}__label {
    color: map-get($colors, "default");
  }

  &__label {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 15px;
    background: map-get($colors, "white");
    color: map-get($colors, "black");
    font-size: 12px;
    line-height: 16px;
    z-index: 9;
    transform: translateY(-50%);
    padding: 0 8px;
  }

  &__input {
    width: 100%;
    padding: 0 15px;
    min-height: 56px;
    max-height: 56px;
    margin: 0;
    outline: none;
    border: 1px solid map-get($colors, "grey_40");
    border-radius: 16px;
    color: map-get($colors, "black");
    font-size: 16px;
    line-height: 24px;

    &:focus {
      border: 2px solid map-get($colors, "default");

      &::placeholder {
        color: transparent;
      }
    }

    &::placeholder {
      color: map-get($colors, "grey_40");
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &__error {
    position: absolute;
    margin-top: 4px;
    margin-left: 17px;
    font-size: 12px;
    line-height: 16px;
    opacity: 0.6;
    letter-spacing: 0;
    color: map-get($colors, "red_error");
  }

  &--error {
    #{$this}__input {
      border: 2px solid map-get($colors, "red_error");
    }

    #{$this}__label {
      color: map-get($colors, "red_error") !important // TODO: Have to refactor (don't have fast decision);
    }
  }
}
</style>
